var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"offer-table"},[_vm._t("offer-table"),_c('vue-button',{on:{"click":function($event){return _vm.$emit('get-offer')}}},[_vm._v("Ajánlatot kérek")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }